import { defaultIconProps, IconProps } from './IconProps';

export const IconHamburgerMenu2: import('react').FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M2.5 10H17.5M2.5 5H17.5M7.5 15H17.5" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconHamburgerMenu2.defaultProps = defaultIconProps;
